import type { QueryClient } from '@tanstack/react-query';
import type { ContentObjectList } from 'models';
import type { InfiniteData } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { getBookmarksFeedInfiniteQueryKey } from 'features/feed/queries/keys';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { getContentObjectIdSafe } from 'features/feed/utils';

type UpdateBookmarksFeedParams = {
  id: string;
  insertableItem?: ContentObjectList;
  isBookmarked: boolean;
  queryClient: QueryClient;
};

/**
 * @deprecated Introduced as part of the #87353 feed refactor to manually patch the React Query cache
 * after each mutation. This ad-hoc cache-patching approach needs a better long-term solution.
 */
export const updateBookmarksFeed = ({ id, insertableItem, isBookmarked, queryClient }: UpdateBookmarksFeedParams) => {
  if (!isBookmarked) {
    queryClient.setQueriesData(
      { queryKey: getBookmarksFeedInfiniteQueryKey({}) },
      (oldData?: InfiniteData<ContentObjectList[]>) => {
        if (!oldData) {
          return oldData;
        }

        return {
          ...oldData,
          pages: oldData.pages.map((page) =>
            page.filter((item: ContentObjectList) => getContentObjectIdSafe(item) !== id),
          ),
        };
      },
    );
    return;
  }

  if (!insertableItem) {
    // Some content objects (e.g. node events) can't be reconstructed into a valid feed item client-side, so we refetch instead
    void queryClient.invalidateQueries({ queryKey: getBookmarksFeedInfiniteQueryKey({}) });
    return;
  }

  queryClient.setQueriesData(
    { queryKey: getBookmarksFeedInfiniteQueryKey({}) },
    (oldData?: InfiniteData<ContentObjectList[]>) => {
      if (!oldData) {
        return oldData;
      }

      const [firstPage, ...restOfPages] = oldData.pages;

      return { ...oldData, pages: [[insertableItem, ...(firstPage ?? [])], ...restOfPages] };
    },
  );
};
